import { render, staticRenderFns } from "./editSupplierCoupon.vue?vue&type=template&id=7222241f"
import script from "./editSupplierCoupon.vue?vue&type=script&lang=js"
export * from "./editSupplierCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports